// extracted by mini-css-extract-plugin
module.exports =  {"container":"RCM4A3Y","divider":"Sdat4mf"};